import { InlineAlert } from '@/components/design-system/InlineAlert';

/** The one line that a screen shows when a refresh failed over data that it already loaded. */
const STALE_NOTICE_TEXT = 'Could not refresh. What you see may be out of date.';

/**
 * A failed background refetch keeps the last good data on screen. That data may no longer
 * be true, so the screen says so. This includes an empty list: it must not read as "none".
 */
export function StaleNotice() {
  return (
    <InlineAlert intent="warning" data-testid="stale-notice">
      {STALE_NOTICE_TEXT}
    </InlineAlert>
  );
}

export const __private = { STALE_NOTICE_TEXT };
